<template>
  <b-card no-body class="my-2" style="border-radius: 0 !important;">
    <div class="row p-3">
      <span class="small" style="opacity: 0.65;">{{ name }}<span class="text-danger" v-if="isRequired">*</span></span>
      <div class="col-md-12">
        <span v-for="item in items" :key="item[index]">
          <b-badge variant="primary" class="mr-2 small">{{ item[text] }}</b-badge>
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'TagField',
  props:{
    name: String, 
    items: Array, 
    index: String, 
    text: String, 
    isRequired: Boolean
  }
}
</script>

<style scoped>

</style>
